import { useContextApolloClient } from '@proscom/prostore-apollo-react';
import {
  MUTATION_ACCEPT_SECTION_COMMENTARY,
  MUTATION_REJECT_SECTION_COMMENTARY
} from '../../../graphql/mutations/comment';
import { INFRALIST_QUERIES } from '../infralistQueries';

export const useMakeDecisionSectionCommentaries = () => {
  const client = useContextApolloClient();

  const acceptComment = ({ content, sectionId, infralistId, ids }) => {
    return client.mutate({
      mutation: MUTATION_ACCEPT_SECTION_COMMENTARY,
      variables: {
        content,
        comment_ids: ids,
        section_id: sectionId,
        infralist_id: infralistId
      },
      refetchQueries: [INFRALIST_QUERIES.SECTION_GENERAL_COMMENTARIES]
    });
  };

  const rejectComment = ({ content, sectionId, infralistId, ids }) => {
    return client.mutate({
      mutation: MUTATION_REJECT_SECTION_COMMENTARY,
      variables: {
        content,
        comment_ids: ids,
        section_id: sectionId,
        infralist_id: infralistId
      },
      refetchQueries: [INFRALIST_QUERIES.SECTION_GENERAL_COMMENTARIES]
    });
  };

  return { acceptComment, rejectComment };
};
